import React, { ComponentProps, FC } from 'react';

import { Box, Text } from '@rover/kibble/core';

type Props = Exclude<
  ComponentProps<typeof Box>,
  'webAs' | 'marginTop' | 'marginBottom' | 'paddingLeft'
>;

// standardize styling for unordered lists in FAQs
const UnorderedList: FC<Props> = (props) => (
  <Box webAs="ul" marginTop="2x" marginBottom="0x" paddingLeft="6x" {...props} />
);

export const ListItem: FC<Exclude<ComponentProps<typeof Box>, 'webAs'>> = ({
  children,
  ...props
}) => (
  <Box webAs="li" {...props}>
    <Text>{children}</Text>
  </Box>
);

export default UnorderedList;
